import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import { hotjar } from "react-hotjar";
import { connect, Provider } from 'react-redux';
import store from './store/store';

import './index.css';
import './i18n';

import AppContainer from './App';
import reportWebVitals from './reportWebVitals';
import { RootState } from 'store/types';

if (process.env.NODE_ENV === 'production') {
  hotjar.initialize({ id: 560365, sv: 6 });
}

const mapStateToProps = (state: RootState) => ({
  currentView: state.funnel.currentView
});

const App = connect(mapStateToProps)(AppContainer);

const Init = () => {
  const [isReady, setIsReady] = useState(process.env.NODE_ENV !== 'development');

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      import('./mocks/browser')
        .then(({ worker }) => worker.start({
          onUnhandledRequest(req, print) {
            const excludedRoutes = [
              'hotjar.com',
              'youtube.com',
              'hot-update',
              'app.min.js',
              'manifest.json',
              'hotjar-560365.js',
              '/api/media/public/landing_page',
              '/log/',
              '/rum/intake/v2/rum/events',
              'content/injected',
              '/static/media/',
            ];
            const isExcluded = excludedRoutes.some(route =>
              req.url.origin.includes(route) ||
              req.url.pathname.includes(route) ||
              req.url.pathname.endsWith('.png')
            );
            if (isExcluded) {
              return;
            }
            print.warning();
          },
          serviceWorker: {
            url: '/mockServiceWorker.js'
          }
        }))
        .then(() => setIsReady(true))
        .catch(err => {
          console.error('Failed to start the worker:', err);
          setIsReady(true); // or handle the error state differently
        });
    }
  }, []);

  if (!isReady) {
    return <div>Loading...</div>; // Placeholder for loading state
  }


  return (
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<Init />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
